module.exports = __webpack_public_path__ + "80a72e0078051011b483cab97154d341.svg";